import Mustache from "mustache";
import html2pdf from "html2pdf.js";

export async function exportCV(data: any) {
  const response = await fetch("/templates/cv-template.html");
  const template = await response.text();

  const html = Mustache.render(template, data);

  const container = document.createElement("div");
  container.innerHTML = html;
  container.style.background = "#ffffff";

  document.body.appendChild(container);

  const opt = {
    margin: [15, 15, 15, 15],
    image: {
      type: "jpeg",
      quality: 0.95,
    },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollY: 0,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    },
    pagebreak: {
      mode: ["css", "legacy"],
    },
  };

  const pdfBlob = await html2pdf()
    .from(container)
    .set(opt as any)
    .outputPdf("blob");

  const url = URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");

  document.body.removeChild(container);
}
